<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 500px; overflow-y: hidden;" [style.height]="dialogHeight" data-cy="case-edit-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="case-edit-dialog-header-section">
      <div class="section-header-title" data-cy="case-edit-dialog-title-text">
        {{ dialogTitle }}
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    @if (isLoading) {
      <app-tdo-progress-spinner style="height: 100%;"
      data-cy="case-loading-spinner"></app-tdo-progress-spinner>
    }
    @if (!isLoading) {
      <div class="section-content" style="flex: 1;" data-cy="case-tooth-content">
        <div style="display: flex;" data-cy="case-tooth-selector-row">
          <div
            style="flex-basis: 100px; text-align: right; margin-right: 8px; align-items: center; display: flex; justify-content: flex-end;"
            data-cy="case-tooth-label">Tooth: <span style="color: red;">*</span></div>
            <div style="flex: 1;">
              <tdo-input type="text" [value]="selectedTooth?.cfgToothDescriptions?.[0]?.NotationDescription" isReadOnly="true" widthString="100%"
              data-cy="case-tooth-input"></tdo-input>
            </div>
            <div (click)="onOpenToothSelector()" matTooltip="Select Tooth"
              style="cursor: pointer; color: var(--tdo-secondary); align-items: center; display: flex; justify-content: flex-end;"
              data-cy="case-tooth-selector-button"><lucide-icon name="more-horizontal" [size]="20"></lucide-icon></div>
            </div>
            @if (isToothRequired) {
              <div style="color: red; font-size: 12px; margin-left: 108px; margin-top: 2px;">Tooth is
              required</div>
            }
            <div style="display: flex;" data-cy="case-procedure-row">
              <div
                style="flex-basis: 100px; text-align: right; margin-right: 8px; align-items: center; display: flex; justify-content: flex-end;"
                data-cy="case-procedure-label">Procedure: @if (data.mode !== 'editCase') {
                <span style="color: red;">*</span>
              }</div>
              <div style="flex: 1;">
                @if (data.mode !== 'editCase') {
                  <tdo-input type="text" [value]="selectedCaseProcedure?.ProcedureName"
                  isReadOnly="true" widthString="100%" data-cy="case-procedure-input"></tdo-input>
                }
                @if (data.mode === 'editCase') {
                  <tdo-input isReadOnly="true" type="text"
                  [value]="selectedCaseProcedure.ProcedureName" widthString="100%" data-cy="case-procedure-input"></tdo-input>
                }
              </div>
              @if (data.mode !== 'editCase') {
                <div (click)="onOpenProcedureSelector()" matTooltip="Select Procedure"
                  style="cursor: pointer; color: var(--tdo-secondary); align-items: center; display: flex; justify-content: flex-end;"
                  data-cy="case-procedure-selector-button"><lucide-icon name="more-horizontal" [size]="20"></lucide-icon></div>
                }
              </div>
              @if (isProcedureRequired) {
                <div style="color: red; font-size: 12px; margin-left: 108px; margin-top: 2px;">
                Procedure is required</div>
              }
              <div style="display: flex;" data-cy="case-description-row">
                <div
                  style="flex-basis: 100px; text-align: right; margin-right: 8px; align-items: center; display: flex; justify-content: flex-end;"
                  data-cy="case-description-label">Description: <span style="color: red;">*</span></div>
                  <div style="flex: 1;">
                    <tdo-input type="text" [value]="caseForToothModel.Description" widthString="100%"
                    (inputFinished)="caseForToothModel.Description = $event" data-cy="case-description-input"></tdo-input>
                  </div>
                </div>
                @if (isDescriptionRequired) {
                  <div style="color: red; font-size: 12px; margin-left: 108px; margin-top: 2px;">
                  Description is required</div>
                }
                <div style="display: flex;" data-cy="case-doctor-row">
                  <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 5px;"
                    data-cy="case-doctor-label">Doctor: <span style="color: red;">*</span></div>
                    <div style="flex: 1;">
                      @if (doctors && doctors.length > 0) {
                        <tdo-dropdown-v2 [datasource]="doctors"
                          [displayPredicate]="doctorPredicate" [value]="getDoctor(caseForToothModel.DoctorId)"
                          [disabledPredicate]="doctorDisabledPredicate"
                        (selectionChange)="onDoctorSelectionChange($event)" data-cy="case-doctor-dropdown"></tdo-dropdown-v2>
                      }
                    </div>
                  </div>
                  @if (isDoctorRequired) {
                    <div style="color: red; font-size: 12px; margin-left: 108px; margin-top: 2px;">Doctor is
                    required</div>
                  }
                  <div style="display: flex;" data-cy="case-referrer-row">
                    <div
                      style="flex-basis: 100px; text-align: right; margin-right: 8px; align-items: center; display: flex; justify-content: flex-end;"
                      data-cy="case-referrer-label">Referrer: <span style="color: red;">*</span></div>
                      <div style="flex: 1;">

                        <dx-select-box style="height: 46px;"
                          [inputAttr]="{ placeholder: '' }"
                          [dataSource]="selectReferringDoctorBoxDataSource" 
                          [searchEnabled]="true" 
                          [searchExpr]="['Fullname']"
                          displayExpr="Fullname" 
                          valueExpr="DoctorId" 
                          [(value)]="caseForToothModel.ReferralDoctorId"
                          placeholder="Select a Referring Doctor ..." 
                          [dropDownOptions]="dropDownOptions"
                          (onValueChanged)="onReferringDoctorValueChanged($event)"
                          data-cy="case-referrer-dropdown">
                        </dx-select-box>

                      </div>
                    </div>
                    @if (isReferringDoctorRequired) {
                      <div style="color: red; font-size: 12px; margin-left: 108px; margin-top: 2px;">
                      Referring Doctor is required</div>
                    }
                    <div style="display: flex;" data-cy="case-status-row">
                      <div
                        style="flex-basis: 100px; text-align: right; margin-right: 8px; align-items: center; display: flex; justify-content: flex-end;"
                      data-cy="case-status-label">Status:</div>
                      <div style="flex: 1;">
                        <app-tdo-enum-select componentStyle="width:100%" name="enumCaseStatus"
                          componentUniqueID="case-edit-dialog-case-status-dropdown" placeholder="Case Status"
                          placeholderPosition="above" [validValueItemId]="caseForToothModel.enumCaseStatusID"
                          (enumSelected)="caseForToothModel.enumCaseStatusID = $event.ValidValueItemId"
                        data-cy="case-status-dropdown"></app-tdo-enum-select>
                      </div>
                    </div>
                    @if (parentCaseId) {
                      <div style="display: flex;" data-cy="case-parent-row">
                        <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 5px;"
                        data-cy="case-parent-label">Main Case:</div>
                        <div style="flex: 1;">
                          <tdo-dropdown-v2 [displayPredicate]="casePredicate" [datasource]="allCases" [value]="getParentCase()"
                            (selectionChange)="onParentCaseChange($event)" data-cy="case-parent-dropdown"
                          componentStyle="width:100%"></tdo-dropdown-v2>
                        </div>
                      </div>
                    }
                    @if (data.mode === 'editCase') {
                      <div>
                        <div style="color: red; font-size: 12px; margin-left: 40px; margin-right: 40px; text-align: justify;"><b>WARNING:</b> Changing the
                        tooth number will affect all forms, including Diagnosis and Treatment. Values pertaining to specific canals
                        could be deleted or overwritten. Please review these forms and save notes as needed before making this change.
                      </div>
                    </div>
                  }
                </div>
              }
              <!--  FOOTER-->
              @if (!isLoading) {
                <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;"
                  data-cy="case-footer-section">
                  <div style="flex: 1; margin-right: 6px;"></div>
                  <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;"
                  data-cy="case-cancel-button">Cancel</button>
                  <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" [disabled]="!isFormValid()"
                  data-cy="case-ok-button">{{okButtonCaption}}</button>
                </div>
              }
            </div>
          </div>